// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__17EsD","header":"PatientBlock_header__4YUEL","label":"PatientBlock_label__1IsOw","option":"PatientBlock_option__Uler-"};